import React ,{ useEffect, useRef, useState } 
from "react";
import { FormProvider, useForm } from "react-hook-form";
import CpntFormSectionContainer from "../../../components/forms/CpntFormSectionContainer";
import CpntFormSection from "../../../components/forms/CpntFormSection";

import { getDefaultFilterMarque, IFilterMarque } from "../../../models/interfaces/IFilterMarque";

import CpntForm from "../../../components/forms/CpntForm";

import { useFetchCompteGetAllMarquesQuery } from "../../../redux/slice/api/FO/compteApi";
import { useKeycloak } from "@react-keycloak/web";

import CpntMultiSelect from "../../../components/CpntMultiSelect";
import CpntFilterButtons from "../../../components/CpntFilterButtons";



interface IProps {
  filter?: IFilterMarque;
  changeFilter: (data: IFilterMarque) => void;
}


//Arrive pas a faire passer unb param au parent...
const MarquesFilter: React.FC<IProps> = ({ filter, changeFilter }) => {
  const { initialized: keycloakinitialized,keycloak } = useKeycloak();
  const { data: marques } = useFetchCompteGetAllMarquesQuery(undefined, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated 
  });
  const prevFilterRef = useRef<IFilterMarque | undefined>(filter);

  useEffect(() => {
    if (JSON.stringify(prevFilterRef.current) !== JSON.stringify(filter) || getValues() !== JSON.stringify(filter)) {
      reset(filter);
    }
    prevFilterRef.current = filter;
  }, [filter]);

  
  const formMethods = useForm<IFilterMarque>({
    defaultValues: getDefaultFilterMarque(),
  });

  const { handleSubmit, reset,getValues } = formMethods;
  const [selectedIds, setSelectedIds] = useState<any[]>([]);

  const handleResetForm = () => {
    localStorage.removeItem("IFilterMarques");
    setSelectedIds([]);
    changeFilter(getDefaultFilterMarque());
    reset(getDefaultFilterMarque()); // Réinitialise explicitement le formulaire
  };

  const handleSubmitForm = () => {
    handleSubmit(onSubmit)();
  };

  const onSubmit = (data: IFilterMarque) => {
    const idsOnly = selectedIds.map((option: { value: any }) => option.value);
    const combinedData: IFilterMarque = {
      ...data,
      SocieteIds: idsOnly,
    };
    changeFilter(combinedData);
    localStorage.setItem("IFilterMarques",JSON.stringify(combinedData)); //need ??
  };


  const handleKeyPress = (e: { key: string; preventDefault: () => void; }) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      //SubmitButton.current.click();
    }
  };
  useEffect(() => {
      if (filter?.SocieteIds) {
        const selectedValues = marques?.Marques?.filter((marque: { Id: any }) =>
          filter?.SocieteIds?.includes(marque.Id)
        ) || [];
  
        // Create an object from selectedValues to map to options
        const selectedValuesList = selectedValues?.map((marque: { Libelle: any; Id: any }) => {
          return {
            label: marque.Libelle,
            value: marque.Id,
          };
        });
        setSelectedIds(selectedValuesList);
      }
    }, [marques]);
  const mappedOptions = marques?.Marques || [];
  
  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)} onKeyDown={handleKeyPress} >
        <CpntForm>
        <CpntFormSection pSectionLabel="Informations commerciales">
          <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[8, 12]}>
          {/* <label>
          Sélectionner une marque
          </label> */}
          <CpntMultiSelect 
            DefaultLibelle="Sélectionner..."
            options={mappedOptions}
            value={selectedIds}
            setSelected={setSelectedIds}
            label="Sélectionner une marque"
            ></CpntMultiSelect>
            <CpntFilterButtons  
              resetForm={handleResetForm}
              submitForm={handleSubmitForm}
            />
          </CpntFormSectionContainer>
        </CpntFormSection>
        </CpntForm>
        
      </form>
    </FormProvider>
  );
};

export default MarquesFilter;
